import { render } from "./ApprovalsHome.vue?vue&type=template&id=057e6ffb&scoped=true"
import script from "./ApprovalsHome.vue?vue&type=script&lang=js"
export * from "./ApprovalsHome.vue?vue&type=script&lang=js"

import "./ApprovalsHome.vue?vue&type=style&index=0&id=057e6ffb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057e6ffb"]])

export default __exports__